export const REVIEW_MEMBERS_TABS = {
  CUSTOM: 'custom',
  DEFAULT: 'default',
  INELIGIBLE: 'ineligible'
} as const;

export const TAB_DESCRIPTIONS: Record<string, string> = {
  [REVIEW_MEMBERS_TABS.CUSTOM]:
    'These members have settings different from the group.',
  [REVIEW_MEMBERS_TABS.DEFAULT]:
    "These members follow the group's settings. Uncheck anyone who should stay as they are.",
  [REVIEW_MEMBERS_TABS.INELIGIBLE]: "These members can't be updated right now"
};

export const TAB_EMPTY_MESSAGES: Record<string, string> = {
  [REVIEW_MEMBERS_TABS.CUSTOM]: 'No custom members found.',
  [REVIEW_MEMBERS_TABS.DEFAULT]: 'No default members found.',
  [REVIEW_MEMBERS_TABS.INELIGIBLE]: 'No ineligible members found.'
};

export const INELIGIBLE_REASON_LABELS: Record<string, string> = {
  different_interval: 'Different interval',
  payment_order_exists: 'Payment order exists',
  inactive: 'Inactive',
  deactivated: 'Deactivated',
  course_discontinued: 'Course discontinued'
};

export const getIneligibleReasonLabel = (reason: string): string => {
  const parts = reason.split(',').map((r) => r.trim());
  return parts
    .map(
      (part) =>
        INELIGIBLE_REASON_LABELS[part] ||
        part.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
    )
    .join(', ');
};
